import { dashboard } from './DashBoard';
import { master } from './master';

import { Admin } from './admin';
import { other } from './other';
import { jd } from './accounts';

//-----------------------|| MENU ITEMS ||-----------------------//

const menuItems = {
    items: [dashboard, Admin, jd, master, other]
};

export default menuItems;
